module.exports = __webpack_public_path__ + "media/src/images/icon/fa-arrow-right-ee05262640415cbc9ee4d2d7f6429a6e.gif";